export default {
  authentication: {
    components: {
      forgotPassword: {
        backButtonText: 'Volver'
      },
      login: {
        emailAccount: {
          backButtonText: 'Volver'
        }
      },
      registration: {
        contactPreferences: {
          skipButtonText: 'Omitir este paso'
        },
        createAccount: {
          backButtonText: 'Volver'
        }
      }
    },
    hooks: {
      useAuthPageProps: {
        landing: {
          heading: 'Crear una cuenta.',
          title: 'Crear una cuenta.'
        },
        loginLanding: {
          heading: 'Iniciar sesión.',
          title: 'Iniciar sesión.'
        },
        loginForm: {
          heading: 'Iniciar sesión.',
          title: 'Iniciar sesión.'
        },
        createAccount: {
          heading: 'Crear una cuenta.',
          title: 'Crear una cuenta'
        },
        resetPassword: {
          heading: '¿Has olvidado tu contraseña?',
          title: '¿Has olvidado tu contraseña?'
        },
        contactPreferences: {
          heading: 'Mantente en contacto.',
          title: 'Mantente en contacto'
        },
        forgotPassword: {
          heading: '¿Has olvidado tu contraseña?',
          title: '¿Has olvidado tu contraseña?'
        },
        emailSentConfirmation: {
          verifyAccount: {
            heading: 'Vamos a verificar tu cuenta.',
            title: 'Verifica tu cuenta'
          },
          resetPassword: {
            heading: 'Comprueba tu bandeja de entrada.',
            title: 'Comprueba tu bandeja de entrada'
          }
        },
        success: {
          "default": {
            heading: '¡Ya está todo listo!',
            title: '¡Ya está todo listo!'
          },
          accountAlreadyVerified: {
            heading: 'Ya hemos verificado tu cuenta.',
            title: 'Ya hemos verificado tu cuenta'
          }
        },
        resetPasswordSuccess: {
          heading: 'Tu contraseña ha sido cambiada',
          title: 'Tu contraseña ha sido cambiada'
        },
        error: {
          "default": {
            heading: 'Crear cuenta.',
            title: 'Algo no ha salido bien.'
          },
          errorWithRetrySignUp: {
            heading: 'Algo no ha salido bien.',
            title: 'Algo no ha salido bien'
          },
          errorWithResendEmail: {
            heading: 'Lo sentimos, algo ha ido mal.',
            title: 'Lo sentimos, algo ha ido mal'
          },
          linkExpiredWithResendEmail: {
            heading: 'Link de verificación caducado.',
            title: 'Link de verificación caducado.'
          },
          passwordResetTokenExpired: {
            heading: 'Link de contraseña caducado.',
            title: 'Link de contraseña caducado'
          }
        }
      },
      useAuthStatusProps: {
        success: {
          buttonText: 'Llévame de vuelta al inicio',
          buttonTextLogin: 'Pulsa aquí para iniciar sesión',
          heading: '¡Éxito!',
          subheading: 'Iniciado sesión como:'
        },
        error: {
          buttonText: 'Inténtalo otra vez',
          heading: 'Algo no ha salido bien.',
          subheading: 'Prueba otra vez a crear una cuenta.',
          resetPassword: {
            withRetry: {
              buttonText: 'Reintentar',
              content: '¡Lo sentimos! Intenta hacer clic a continuación para enviar un nuevo email de verificación.'
            },
            withResendEmail: {
              buttonText: 'Reenviar email',
              content: '¡Lo sentimos! Intenta hacer clic a continuación para enviar un nuevo email de verificación'
            },
            tokenExpired: {
              buttonText: 'Reenviar email',
              content: 'El link que te enviamos ya no es válido, lo hacemos para mantener segura tu cuenta. Haz clic a continuación para enviar un nuevo email de restablecimiento de contraseña olvidada.'
            }
          }
        },
        resetPasswordSuccess: {
          buttonText: 'Iniciar sesión con tu cuenta',
          contentPartOne: 'Puedes actualizar tu contraseña en cualquier momento',
          contentPartTwo: 'Ajustes'
        }
      },
      useStepperProps: {
        steps: {
          first: 'Crear una cuenta',
          second: 'Preferencias',
          third: 'Completar'
        }
      }
    }
  },
  myHub: {
    collection: {
      calloutText: 'Guarda contenido y crea colecciones con una cuenta gratuita',
      errorMessage: 'No se han podido cargar los siguientes resultados. Por favor prueba más tarde.',
      loadNext: 'Cargar siguientes',
      taglineItem_one: 'elemento',
      taglineItem_few: 'elementos',
      taglineItem_many: 'elementos',
      taglineItem_other: 'elementos',
      taglineItem: 'elemento',
      taglineItem_plural: 'elementos',
      taglineItem_0: 'elemento',
      taglineItem_1: 'elementos',
      taglineItem_2: 'elementos'
    },
    collections: {
      taglineSaved: 'guardado',
      createButtonText: 'Crear una nueva colección',
      loadErrorMessage: 'No hemos podido cargar los siguientes artículos. Por favor, inténtalo más tarde.',
      loadNext: 'Cargar siguientes',
      tagline_one: 'Colección',
      tagline_few: 'Colecciones',
      tagline_many: 'Colecciones',
      tagline_other: 'Colecciones',
      tagline: 'Colección',
      tagline_plural: 'Colecciones',
      tagline_0: 'Colección',
      tagline_1: 'Colecciones',
      tagline_2: 'Colecciones'
    },
    components: {
      savedItem: {
        card: {
          ariaLabel: {
            save: 'Guardar',
            unsave: 'Eliminar'
          }
        }
      },
      searchFilter: {
        ariaLabel: {
          searchButton: 'Buscar'
        },
        filteredResultsHeading: 'Mostrando resultados para: ',
        sr: {
          filteredItemsResults_one: 'resultado',
          filteredItemsResults_few: 'resultados',
          filteredItemsResults_many: 'resultados',
          filteredItemsResults_other: 'resultados',
          filteredItemsResults: 'resultado',
          filteredItemsResults_plural: 'resultados',
          filteredItemsResults_0: 'resultado',
          filteredItemsResults_1: 'resultados',
          filteredItemsResults_2: 'resultados'
        }
      }
    },
    overview: {
      createButtonText: 'Crear una colección nueva',
      defaultTitle: 'Mi Zona',
      ugcButtonLabel: 'Ver más',
      ugcCreateButtonText: 'Añadir receta'
    },
    ownItems: {
      createButtonText: 'Añadir receta nueva',
      loadErrorMessage: 'No se han podido cargar los siguientes resultados. Por favor prueba más tarde.',
      loadNext: 'Cargar siguientes',
      tabData: {
        all: 'Todos',
        published: 'Publicado',
        unpublished: 'Descartado'
      },
      tabFilterError: 'Ha habido un problema al filtrar tus recetas. Aquí tienes todas las recetas.'
    },
    savedItems: {
      collectionTaglineItem_one: 'artículo',
      collectionTaglineItem_few: 'artículos',
      collectionTaglineItem_many: 'artículos',
      collectionTaglineItem_other: 'artículos',
      collectionTaglineItem: 'artículo',
      collectionTaglineItem_plural: 'artículos',
      collectionTaglineItem_0: 'artículo',
      collectionTaglineItem_1: 'artículos',
      collectionTaglineItem_2: 'artículos',
      collectionTaglineSaved: 'guardado',
      loadErrorMessage: 'No hemos podido cargar los siguientes artículos. Por favor, inténtalo más tarde.',
      loadNext: 'Cargar siguientes'
    }
  },
  nextCore: {
    signIn: {
      errorLineOne: '¿Buscas algo en particular?',
      errorLineTwo: 'Prueba',
      errorLineThree: 'Iniciando sesión',
      errorLineFour: 'Para ver esta página.',
      errorLineFive: '¿Aún no tienes una cuenta gratuita?',
      errorLineSix: 'Únete aquí'
    }
  },
  postCreator: {
    confirmation: {
      metaTitle: 'Crea una receta - Gracias',
      newRecipeButtonText: 'Nueva Receta',
      ownRecipeButtonText: 'Mis Recetas'
    },
    create: {
      metaTitle: 'Crear una Receta'
    },
    edit: {
      editFormTitle: 'Editar Receta',
      metaTitle: 'Editar Receta'
    },
    recipeDetails: {
      dropDownOptions: {
        hours: 'horas',
        mins: 'minutos'
      },
      heading: 'Detalles de la Receta',
      label: {
        cookTime: 'Tiempo de cocción (aprox.)',
        difficulty: 'Nivel de Dificultad',
        extraTime: 'Tiempo Extra (Opcional)',
        image: 'Imagen',
        prepTime: 'Tiempo de preparación (aprox.)',
        servings: 'Raciones',
        shortIntro: 'Intro breve (10-15 palabras)',
        title: 'Título de la Receta (Corto y descriptivo)'
      },
      placeholder: {
        extraTime: 'e.g. más reposo',
        makes: 'e.g. 8 piezas',
        serves: 'e.g. 4',
        shortIntro: 'Cuéntanos sobre tu receta',
        title: 'e.g. Tarta de manzana de la abuela'
      },
      servingsButton: {
        makes: 'Unidades',
        serves: 'Raciones'
      },
      skillLevel: {
        dropDownOptions: {
          challenge: 'Un desafío',
          defaultText: '(Por favor, selecciona uno)',
          easy: 'Fácil',
          moreEffort: 'Más difícil'
        }
      }
    },
    recipeForm: {
      defaultFeedback: {
        error: 'Ups... Lo sentimos, algo ha ido mal',
        info: 'Por favor guarda la imagen antes de mandarla'
      },
      links: {
        back: 'Volver a mis recetas',
        preview: 'Previsualizar',
        saveDraft: 'Guardar boceto'
      }
    },
    recipeIngredients: {
      heading: 'Ingredientes',
      information: {
        lineOne: 'Por favor usa una medida si es posible (tenemos una útil',
        lineTwo: 'guía de conversión',
        lineThree: 'para ayudar)',
        lineFour: 'Puedes dividir tus ingredientes en grupos e.g. salsas, rellenos etc.'
      },
      ingredient: {
        buttonText: 'Añadir siguiente ingrediente',
        label: 'Ingrediente',
        placeholder: '500g de contramuslos de pollo, en dados'
      },
      ingredientGroup: {
        buttonText: 'Añadir título de sección',
        heading: 'Título',
        placeholder: 'Para la salsa'
      }
    },
    recipeMethodSteps: {
      heading: 'Método',
      method: {
        buttonText: 'Añadir siguiente paso',
        label: 'Paso',
        placeholder: 'Primero, hierve el arroz'
      }
    },
    statusFeedback: {
      createLinkeText: 'crear una receta nueva',
      info: {
        approved: 'Tu receta ha sido aprobada',
        "default": 'Ups, algo ha ido mal',
        draft: 'Tus recetas no han sido enviadas aún',
        pending: 'Tu receta está esperando approbación',
        rejected: 'Tu receta no ha sido aprobada'
      },
      submissionChoice: {
        approved: 'Ver tu receta',
        "default": 'Volver a tu zona',
        draft: 'continuar editando tu receta',
        heading: 'Puede que te apetezca'
      },
      submittedText: 'Tu receta ha sido enviada para ser aprobada y ya no puede ser editada'
    },
    submit: {
      formValidation: {
        defaultMessage: 'Por favor, confirma que has leído nuestros términos y condiciones'
      },
      informationLineOne: 'Por favor, sólo subas tus propias recetas.',
      informationLineTwo: 'Por motivos de copyright no publicaremos ninguna receta subida',
      informationLineThree: 'Por favor, sólo subas tus propias recetas. Por motivos de copyright, no podemos publicar recetas subidas por nuestros usuarios si originalmente fueron escritas por cualquier otra fuente. Puedes leer nuestros términos y condiciones antes de subir tu receta.',
      informationLineFour: 'términos y condiciones',
      informationLineFive: 'para más información antes de enviar tu receta.',
      metaTitle: 'Crear una Receta - Términos y Condiciones',
      previewButtonText: 'Previsualizar',
      publishButtonText: 'Publicar',
      termsLabel: 'Haz click para confirmar que has leído nuestros términos y condiciones.'
    }
  }
};